import {
  Ban,
  CalendarClock,
  CalendarPlus,
  Fingerprint,
  Key,
  KeyRound,
  ListRestart,
  Mail,
  ShieldAlert,
  UserCheck,
  type LucideIcon,
} from 'lucide-react';
import type { ActionLogEntry } from '@/types';

/**
 * Chip colour and icon per `license_event_type`, grouped by what the event
 * means for the licence rather than by its literal name - the same five
 * groups (amber/blue/green/red/slate) the design canvas's own audit table
 * uses for `license.reset`, `user.password_reset`, `license.extend`,
 * `license.revoke` and `license.expire`.
 */
export const EVENT_STYLE: Record<
  ActionLogEntry['eventType'],
  { bg: string; fg: string; icon: LucideIcon }
> = {
  key_generated: { bg: '#FEF3C7', fg: '#B45309', icon: Key },
  key_regenerated: { bg: '#FEF3C7', fg: '#B45309', icon: KeyRound },
  activated: { bg: '#E7F6EC', fg: '#15803D', icon: UserCheck },
  password_reset: { bg: '#F1F5F9', fg: '#5b7ef0', icon: Mail },
  extended: { bg: '#E7F6EC', fg: '#15803D', icon: CalendarPlus },
  fingerprint_mismatch_soft: { bg: '#EEF1F5', fg: '#64748B', icon: Fingerprint },
  fingerprint_mismatch_hard: { bg: '#FEE2E2', fg: '#B91C1C', icon: Fingerprint },
  grace_started: { bg: '#EEF1F5', fg: '#64748B', icon: CalendarClock },
  grace_expired: { bg: '#EEF1F5', fg: '#64748B', icon: CalendarClock },
  blocked: { bg: '#FEE2E2', fg: '#B91C1C', icon: ShieldAlert },
  // A disabled user enabled again, and a seat's machine released: both give
  // access back, so green and slate as the groups above.
  unblocked: { bg: '#E7F6EC', fg: '#15803D', icon: UserCheck },
  released: { bg: '#EEF1F5', fg: '#64748B', icon: ListRestart },
  revoked_by_admin: { bg: '#FEE2E2', fg: '#B91C1C', icon: Ban },
  revoked_by_server: { bg: '#FEE2E2', fg: '#B91C1C', icon: Ban },
  expired: { bg: '#EEF1F5', fg: '#64748B', icon: ListRestart },
};
